import React from 'react';
import { NUMEROLOGY_URL } from "../config";
import { Calendar, ArrowRight } from 'lucide-react';

export const CallToAction = () => {
  return (
    <section 
      className="py-20 relative"
      style={{
        background: `linear-gradient(rgba(252, 202, 199, 0.9), rgba(252, 202, 199, 0.9)), url('https://images.unsplash.com/photo-1731089061691-8bcf88435dc7')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="container">
        <div className="max-w-4xl mx-auto text-center">
          <Calendar className="h-16 w-16 text-amber-600 mx-auto mb-6" />
          
          <h2 className="heading-1 mb-6 text-gray-800">
            Mulailah Perjalanan Mengenal Diri Anda Sekarang
          </h2>
          
          <p className="body-large mb-8 text-gray-700 max-w-2xl mx-auto">
            Cukup dengan tanggal lahir Anda, dapatkan analisis numerologi lengkap 
            yang akan membuka pintu pemahaman diri yang lebih mendalam.
          </p>
          
          <div className="bg-white/90 backdrop-blur-sm border border-white/30 rounded-2xl p-8 mb-8 max-w-lg mx-auto">
            <h3 className="heading-3 mb-4 text-gray-800">Anda Akan Mendapatkan:</h3>
            <ul className="space-y-3 text-left">
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Analisis karakteristik alami</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Bakat dan keunikan diri</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Sisi gelap yang mungkin tidak disadari</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Daftar profesi, karir dan bisnis yang cocok dengan tujuan hidup</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Potensi relationship dengan orang lain</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Potensi kesehatan mental maupun fisik</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Potensi energi suasana rumah</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Potensi pelajaran karma, dan lainnya</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Dapatkan update konten terbaru selamanya</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                <span className="body-medium text-gray-700">Salinan dokumen dapat dicetak atau disimpan sebagai PDF</span>
              </li>
            </ul>
          </div>

          <a href={NUMEROLOGY_URL} className="btn-primary text-lg px-8 py-4 inline-flex items-center gap-3">
            <Calendar className="h-5 w-5" />
            Masukkan Tanggal Lahir dan Nama Lahir Anda
            <ArrowRight className="h-5 w-5" />
          </a>
          
          <p className="caption mt-4 text-gray-600">
            1x Seumur Hidup • Privasi Terjamin
          </p>
        </div>
      </div>
    </section>
  );
};